import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { globalGetService, globalPostService, globalPutService } from "../../../../globalServices";
import { checkApiStatus } from "../../../utils_v2";
import { trackActivity } from "../../../../utils/mixpanel";
import { PageLoader } from "../../../shared_elements";
import { useSnackbar } from "notistack";
import { Autocomplete } from "@material-ui/lab";
import { regexConstants } from "../../../../constants/regEx";
import ErrorPopUp from "../../../shared_elements/ErrorPopUp";
import { jetStreamInstance } from "../../../../shared/components";

const AddEditSvEvents = ({ params, toggleModalFn, addEditSvEvents, modeType, getResponseBack }) => {
    const [data, setData] = useState(addEditSvEvents?.data);
    const [error, setError] = useState({ modal: false, data: null });
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [categoryInfo, SetCategoryInfo] = useState([]);
    const [pltConstants, setPltConstants] = useState([])

    useEffect(() => {
        getPltConstants();
        if (modeType === 'add' || modeType === 'edit') {
            getcategory();
        }
    }, []);

    const onFieldChange = (key, value) => {
        setData({ ...data, [key]: value })
    }

    const getPltConstants = () => {
        globalPostService('console/get-constants/', { constant_types: ['asset_type'] })
            .then(response => {
                if (checkApiStatus(response)) {
                    setPltConstants(response.data.data)
                }
            })
    }

    const getcategory = () => {
        globalGetService(`config-data/categories/?lite=true`)
            .then(response => {
                if (checkApiStatus(response)) {
                    let categoryInfo = [];
                    const data = response?.data?.data;
                    data && data.map((item) => {
                        categoryInfo.push({ id: item?.id, name: item?.name })
                    });
                    SetCategoryInfo(categoryInfo);
                }
            })
    }

    const isDataChanged = () => {
        const originalData = addEditSvEvents?.data || {};
        return (
            data?.name !== originalData?.name ||
            data?.category?.id !== originalData?.category?.id ||
            data?.hours !== originalData?.hours ||
            data?.cycles !== originalData?.cycles ||
            data?.months !== originalData?.months ||
            data?.asset_type?.value !== originalData?.asset_type?.value||
            data?.remarks !== originalData?.remarks
        );
    };

    const onAddEditSvEvents = () => {
        let validationInputs = {
            name: data?.name?.trim() ? '' : 'Please enter SV Events Name',
            asset_type: data?.asset_type ? '' : "Please select Asset Type",
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            setLoading(true);
            let payload = Object.assign({}, data);

            payload = {
                id: payload?.id ? payload?.id : null,
                name: payload?.name ? payload?.name : null,
                category: payload?.category ? payload?.category : null,
                hours: payload?.hours ? parseFloat(payload?.hours) : null,
                cycles: payload?.cycles ? parseFloat(payload?.cycles) : null,
                months: payload?.months ? parseFloat(payload?.months) : null,
                asset_type: payload?.asset_type ? payload?.asset_type : null,
                remarks: payload?.remarks ? payload?.remarks : null,
            }
            const apiUrl = data?.id ? `config-data/sv-events/bulk-update/` : `config-data/sv-events/`;
            const apiMethod = data?.id ? globalPutService : globalPostService;
            apiMethod(apiUrl, [payload])
                .then((response) => {
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                        toggleModalFn();
                        getResponseBack();
                        setLoading(false);
                        trackActivity('Console Management', {
                            event_desc: data?.id ? 'Shop Visit Events Updated Successfully' : 'Shop Visit Events Added Successfully',
                            page_title: 'Config Data : Shop Visit Events',
                            event_type: data?.id ? 'Item Updated' : 'Item Added',
                            updated_id: data?.id || null,
                            success_msg: response?.data?.message
                        })
                    } else {
                        getResponseBack();
                        setError({ modal: true, data: response?.data?.error_details })
                        setLoading(false);
                        trackActivity('Console Management', {
                            event_desc: data?.id ? 'Shop Visit Events Updation Failed' : 'Shop Visit Events Added Failed',
                            page_title: 'Config Data : Shop Visit Events',
                            event_type: data?.id ? 'Item Updated' : 'Item Added',
                            item_id: data?.id || null,
                            error_msg: response?.data?.message
                        })
                    }
                })
        } else {
            setError(validationInputs);
        }
    }
    return (
        <>
            <Dialog
                open={true}
                className='console-management-modal'
            >
                <DialogTitle id="scroll-dialog-title">
                    {modeType === 'edit' ? 'Edit ' : modeType === 'view' ? 'View' : 'Add '} Shop Visit Event
                </DialogTitle>
                <DialogContent dividers>
                    <div>
                        <Grid container spacing={1}>
                            <Grid item md={6}>
                                <TextField
                                    name='name'
                                    label='Name'
                                    disabled={modeType === 'view'}
                                    required={modeType !== 'view'}
                                    value={data?.name || ''}
                                    fullWidth
                                    margin="normal"
                                    inputProps={{ maxLength: 150 }}
                                    onChange={(e) => onFieldChange('name', e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                    error={error?.name || ''}
                                    helperText={error?.name || ''}
                                    onFocus={() => setError({ ...error, name: '' })}
                                />
                            </Grid>
                            <Grid item md={6} >
                                <Autocomplete
                                    getOptionLabel={option => option?.label}
                                    options={pltConstants?.filter(optionItem => optionItem?.type === 'asset_type' && (jetStreamInstance ||  optionItem?.value !== 10))}
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                                    id="asset_type"
                                    disabled={modeType === 'view'}
                                    value={data?.asset_type || null}
                                    disableClearable={true}
                                    onFocus={() => setError({ ...error, asset_type: '' })}
                                    onChange={(e, value) => { onFieldChange('asset_type', value); }}
                                    renderInput={params => <TextField placeholder={'Please select Asset Type'}  {...params} label={'Asset Type'} error={error?.asset_type || ''} helperText={error?.asset_type || ''} margin="normal" required fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                />
                            </Grid>
                            <Grid item md={4}>
                                <TextField
                                    name='hours'
                                    label='Hours'
                                    disabled={modeType === 'view'}
                                    value={data?.hours || ''}
                                    fullWidth
                                    margin="normal"
                                    inputProps={{ maxLength: 10 }}
                                    onChange={(e) => regexConstants.decimalnodotstart.test(e.target.value)? onFieldChange('hours', e.target.value) : e.preventDefault()}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item md={4}>
                                <TextField
                                    name='cycles'
                                    label='Cycles'
                                    disabled={modeType === 'view'}
                                    value={data?.cycles || ''}
                                    fullWidth
                                    margin="normal"
                                    inputProps={{ maxLength: 10 }}
                                    onChange={(e) => regexConstants.numberNoSpace.test(e.target.value)? onFieldChange('cycles', e.target.value) : e.preventDefault()}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item md={4}>
                                <TextField
                                    name='months'
                                    label='Months'
                                    disabled={modeType === 'view'}
                                    value={data?.months || ''}
                                    fullWidth
                                    margin="normal"
                                    inputProps={{ maxLength: 5 }}
                                    onChange={(e) => regexConstants.numberNoSpace.test(e.target.value)? onFieldChange('months', e.target.value) : e.preventDefault()}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item md={6} >
                                <Autocomplete
                                    options={(categoryInfo || []).filter((item) => item.id !== data?.category?.id)}
                                    getOptionLabel={option => option?.name || ''}
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                                    id="category"
                                    disabled={modeType === 'view'}
                                    value={data?.category || null}
                                    disableClearable={true}
                                    onChange={(e, value) => { onFieldChange('category', value); }}
                                    renderInput={params => <TextField placeholder={'Please select Category'}  {...params} label={'Category'} margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                />
                            </Grid>
                            <Grid item md={12} >
                                <TextField
                                    name='remarks'
                                    label='Remarks'
                                    disabled={modeType === 'view'}
                                    value={data?.remarks || ''}
                                    fullWidth
                                    margin="normal"
                                    multiline
                                    rows={3}
                                    inputProps={{ maxLength: 255 }}
                                    onChange={(e) => onFieldChange('remarks', e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                        </Grid>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { toggleModalFn(); trackActivity('Console Management', { page_title: 'Config Data : Shop Visit Events', item_type: 'Cancel Button', event_type: 'Item Clicked', event_desc: `Clicked on Cancel Button from ${modeType === 'add' ? 'Add' : modeType === 'view' ? 'View' : 'Edit'} Shop Visit Events form` }) }} color='primary' size='small' variant='outlined'>Cancel</Button>
                    {modeType === 'view' ? null : <Button onClick={() => { onAddEditSvEvents(); trackActivity('Console Management', { page_title: 'Config Data : Shop Visit Events', item_type: 'Save Button ', event_type: 'Item Clicked', event_desc: `Clicked on Save Button from ${modeType === 'add' ? 'Add' : 'Edit'} Shop Visit Events form` }) }} disabled={isLoading || (modeType === 'edit' && !isDataChanged())} color='primary' size='small' variant='contained'>{isLoading ? <CircularProgress size={24} /> : 'Save'}</Button>}
                </DialogActions>
            </Dialog>
            {isLoading ? <PageLoader /> : null}
            {error?.data?.map((item) =>
                <ErrorPopUp
                    toggleModalFn={() => setError({ modal: false, data: null })}
                    modal={error.modal}
                    error={item} />)}
        </>
    )
}

export default AddEditSvEvents